import axios from 'axios';

import { assertClientSide } from '@dr.pogodin/react-utils';

import type { PostUserScoresBodyT, PostUserScoresResT } from 'server/controllers';

import { E_SCORES, P_API_USERS, getConfig } from 'utils';

export type PostUserScoresArgT = PostUserScoresBodyT['scores'];

export async function postUserScores(
  userId: string,
  scores: PostUserScoresArgT,
): Promise<PostUserScoresResT> {
  assertClientSide();

  const config = getConfig(true);

  const res = await axios.post<PostUserScoresResT>(
    `${P_API_USERS}/${userId}${E_SCORES}`,
    {
      _csrf: config.CSRF,
      scores,
    } satisfies PostUserScoresBodyT,
  );

  return res.data;
}
